import { IIdsRequest } from './../../../model/request/IIdsRequest';
import { IPlanChuongTrinhDaoTaoKienThuc } from "../../../model/respone/ctdt/IPlanChuongTrinhDaoTaoKienThuc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eChuongTrinhDaoTaoKienThucActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IPlanChuongTrinhDaoTaoKienThuc[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IPlanChuongTrinhDaoTaoKienThuc | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IPlanChuongTrinhDaoTaoKienThuc,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: {} as IIdsRequest,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",

  CHANGE_SELECTED_IDS: {} as number[]
};
export const eChuongTrinhDaoTaoKienThucIds = generateActionTypeIds(
  eChuongTrinhDaoTaoKienThucActionsObj,
  "CHUONG_TRINH_DAO_TAO_KIEN_THUC"
);
export type IChuongTrinhDaoTaoKienThucActionTypes = IGenericActionType<
  typeof eChuongTrinhDaoTaoKienThucActionsObj,
  "CHUONG_TRINH_DAO_TAO_KIEN_THUC"
>;
